import React, { FC, ReactNode, useEffect } from 'react';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { NeedHelp } from 'aw-package-react-authentication';
import { isLocalhost } from '~/utils/urlUtils';
import { GetCopyrightTranslation, GetDealersExperience } from '~/utils/dealerUtils';
import { getHostName } from 'omni-package-react-cms';
import { getOnpremHostname } from 'omni-package-react-core';
import Configuration from '~/utils/Configuration';
import fixFaviconPath from '~/utils/fixFaviconPath';
import getSitecorePath from '~/utils/getSitecorePath';
import ExperienceCover from '~/components/ExperienceCover';
import { StyledBackground } from './FormLayout.styles';
import FooterWithLogo from './LogoFooter/FooterWithLogo';

export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  const dealersExperience = GetDealersExperience();
  const experienceDetected = dealersExperience !== null ||
    document.location.hostname === process.env.REACT_APP_DOMAIN_NAME ||
    document.location.hash === '#/not-found' ||
    document.location.hash === '#/technical-error' ||
    isLocalhost();
  const sitecoreFooterUrl = getSitecorePath('global/footers/footer-non-authenticated', true, '/api/ssc/aggregate/content/Items/footer/');
  const sitecorePath = getHostName();
  useEffect(() => {
    fixFaviconPath(dealersExperience);
  }, [dealersExperience]);

  return (
    <div className={dealersExperience}>
      <ExperienceCover experienceDetected={experienceDetected} />
      <FormLayoutCore
        noFooterLanguageButton={false}
        mainFooterLinksUrl={sitecoreFooterUrl}
        mainFooterLinksDomain={`${sitecorePath}/cw`}
        noAppHeader
        noHeaderLanguageButton
        contentBackground="transparent"
        headerBackground="white"
        fullContentHeight
        homePageUrl={`${Configuration.Current().idpTenantUrl}/login/signout?fromURI=${getOnpremHostname()}/eemwpnp1/public/gologin/`}
        copyrightText={<FooterWithLogo copyrightText={GetCopyrightTranslation()} dealerExperience={dealersExperience} />}
      >
        <FormLayoutCore.MainHeaderRightContent>
          <NeedHelp />
        </FormLayoutCore.MainHeaderRightContent>
        {children}
      </FormLayoutCore>
      <StyledBackground data-testid="StyledBackground" role="presentation" />
    </div>
  );
};

export default FormLayout;
